import { CommonModule, HashLocationStrategy, LocationStrategy } from '@angular/common';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { forwardRef, NgModule } from '@angular/core';
import { HttpModule } from '@angular/http';
import { MatIconModule, MatPaginatorIntl } from '@angular/material';
import { MatDialogModule } from '@angular/material/dialog';
import { BrowserModule } from '@angular/platform-browser';
import { ToasterModule } from 'angular2-toaster';
import 'hammerjs';
import { BlockUIModule } from 'ng-block-ui';
import {
  RecaptchaFormsModule,
  RecaptchaModule,
  RecaptchaSettings,
  RECAPTCHA_SETTINGS
} from "ng-recaptcha";
import { ChartsModule } from 'ng2-charts';
import { NgxHmCarouselModule } from 'ngx-hm-carousel';
import { NgxMaskModule } from 'ngx-mask';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AuthGuard } from './auth/_guards';
import { AuthInterceptor } from './auth/_guards/auth.interceptor';
import { AuthModule } from './auth/_guards/auth.module';
import { IdentityStorage } from './auth/_models/identity.storage';
import { AuthenticationService } from './auth/_services';
import { MaterialModule } from './material.module';
import { BaseComponent } from './pages/base/base.component';
import { MatPaginatorIntlGerman } from './pages/table-format-page/mat-paginator-int';
import { FooterComponent } from './pages/template/footer/footer.component';
import { HeaderComponent } from './pages/template/header/header.component';
import { PadraoService } from './service/padrao/padrao.service';
import { UsuarioService } from './service/usuario/usuario.service';
import { SolicitacaoDilatacaoComponent } from './pages/solicitacao-dilatacao/solicitacao-dilatacao.component';
import { RouterModule } from '@angular/router';
import { ConfirmacaoSolicitacaoDialogComponent } from './pages/solicitacao-dilatacao/confirmacao-solicitacao-dialog/confirmacao-solicitacao-dialog.component';
import { SuccessDialogComponent } from "./components/dialog/success-dialog/success-dialog.component";
import { ErrorDialogComponent } from "./components/dialog/error-dialog/error-dialog.component";
import { ConsultaCepService } from './service/consulta-cep/consulta-cep.service';
import { MessageService } from './core/message.service';
import { DocUploadComponent } from './components/doc-upload/doc-upload.component';
import { MessageDialogComponent } from './components/message-dialog/message-dialog.component';


const globalSettings: RecaptchaSettings = {siteKey: '6Lc8vGwUAAAAAOsheXbsSd7qKpwLv0t2ECF1i___'};


@NgModule({
  declarations: [
    AppComponent,
    FooterComponent,
    HeaderComponent,
    BaseComponent,
    SolicitacaoDilatacaoComponent,
    ConfirmacaoSolicitacaoDialogComponent,
    SuccessDialogComponent,
    ErrorDialogComponent,
    DocUploadComponent,
    MessageDialogComponent
  ],
  imports: [
    MatDialogModule,
    MatIconModule,
    BrowserModule,
    MaterialModule,
    CommonModule,
    AppRoutingModule,
    HttpClientModule,
    HttpModule,
    NgxMaskModule.forRoot(),
    BlockUIModule.forRoot(),
    ToasterModule.forRoot(),
    AuthModule,
    ChartsModule,
    NgxHmCarouselModule,
    RecaptchaFormsModule,
    RecaptchaModule.forRoot(),
    RouterModule.forRoot([
      { path: 'solicitacao-dilatacao', component: SolicitacaoDilatacaoComponent }
    ])
  ],
  providers: [
    PadraoService, 
    IdentityStorage, 
    AuthGuard, 
    AuthenticationService,
    UsuarioService,
    MessageService,
    ConsultaCepService,
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    {provide: LocationStrategy, useClass: HashLocationStrategy} ,
    {provide: RECAPTCHA_SETTINGS, useValue: globalSettings },
    {
      provide: MatPaginatorIntl,
      useClass: forwardRef(() => MatPaginatorIntlGerman)
    }
  ],
  entryComponents: [
    ConfirmacaoSolicitacaoDialogComponent,
    SuccessDialogComponent,
    ErrorDialogComponent,
    MessageDialogComponent
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
